import { gql } from "@apollo/client/core";

/**
 * TTS for a single speaking-question sentence. Uses `synthesizeSpeech` (plain synthesis), not
 * `synthesizeSpeechWithTimings` — speaking only needs playback, and the timings mutation is
 * pinned to Azure. `src` is required here (unlike the shared codegen'd `SynthesizeSpeechDocument`,
 * which only selects `id`/`filename`/`audioBase64` for its inline-playback caller) since the
 * generated audio is persisted as a `MediaSchema` object on the sentence, not played inline.
 *
 * Hand-written rather than generated: codegen requires a live GraphQL schema endpoint
 * (`GRAPHQL_SCHEMA_URL`) to run, which this change could not reach.
 */
export const SYNTHESIZE_SPEECH_FOR_SENTENCE = gql`
  mutation SynthesizeSpeechForSentence($text: String!, $voice: String) {
    synthesizeSpeech(text: $text, voice: $voice) {
      id
      src
      filename
    }
  }
`;
